<mat-form-field class="cl-device-number-input" *ngIf="inputFormControl">
    <mat-label class="text-contrast">{{deviceInput.displayText}}</mat-label>
    <input
        matInput
        type="number"
        (blur)="onBlur()"
        [disableControl]="!deviceInput.isEnabled"
        class="text-contrast"
        [formControl]="inputFormControl"
        step="{{deviceInput.isEnabled ? step : ''}}"
    />
</mat-form-field>
<span *ngIf="units" class="cl-device-input-units text-contrast">
    {{ units }}
</span>
